import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAboutDetails } from "../aboutModel";

export const getAboutDetails = createAsyncThunk(
  "AboutUs/GetAboutUs",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/AboutUs/GetAboutUs`
      );
      const result = response.data?.Data as any;
      return {
        Title: result?.Title,
        Description: result?.Description,
        Experience: result?.Experience,
        AlterTag: result?.AlterTag,
        AboutImage: result?.AboutImage,
        FacilityList: result?.FacilityList || [],
      } as IAboutDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching about details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateAboutDetails = createAsyncThunk(
  "AboutUs/AddAboutUs",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AboutUs/AddAboutUs`,
        formData
        // {
        //   headers: { "content-type": "multipart/form-data" },
        // }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating about details :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const uploadAboutFacilities = createAsyncThunk(
  "AboutUs/AddAboutUsFacility",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AboutUs/AddAboutUsFacility`,
        formData
        // {
        //   headers: { "content-type": "multipart/form-data" },
        // }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting/updating facilities :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteAboutFacility = createAsyncThunk(
  "AboutUs/DeleteAboutUsFacility",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AboutUs/DeleteAboutUsFacility`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting facility :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
